export const maHeaders = [
    {key: 'originalVsAdded', header: 'Original vs. Added', sortKey: 'original_vs_added'},
    {key: 'ssacd', header: 'SSA State/County Code', sortKey: 'ssacd'},
    {key: 'specialtyCode', header: 'Specialty Code', sortKey: 'specialty_code'},
    {key: 'npi', header: 'National Provider Identifier (NPI) Number', sortKey: 'npi'},
    {key: 'fullName', header: 'Name of Physician or Mid-Level Practitioner', sortKey: 'full_name'},
    {key: 'streetAddress', header: 'Street Address', sortKey: 'street_address'},
    {key: 'city', header: 'City', sortKey: 'city'},
    {key: 'state', header: 'State', sortKey: 'state'},
    {key: 'zipCode', header: 'ZIP Code', sortKey: 'zip_code'},
    {key: 'acceptsNewPatients', header: 'If PCP, Accepts New Patients? (Y/N)', sortKey: 'accepts_new_patients'},
    {
        key: 'specificExceptionToWrittenAgreements',
        header: 'RPPO-Specific Exception to Written Agreements (Y/N)',
        sortKey: 'specific_exception_to_written_agreements',
    },
    {key: 'letterOfIntent', header: 'Letter of Intent? (Y/N) Only Applicable for MA Applicants', sortKey: 'letter_of_intent'},
];
